import { useEffect, useState } from "react";

/**
 * Call inside a composent to get the mounted value (boolean)
 * @param delay delay before mounted component
 */
export const useMounted = (delay = 0) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsMounted(true);
        }, delay);

        return () => {
            clearTimeout(timer);
            setIsMounted(false);
        };
    }, [delay]);

    return isMounted;
};

export default useMounted;
